import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { AuthService } from '../services/auth.service';

/**
 * Login Guard - Redirects authenticated users away from login page
 *
 * If user is already authenticated:
 * - Admin → /dashboard
 * - Bidder → /bid-sheets
 *
 * If user is not authenticated:
 * - Allow access to login page
 */
export const loginGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const user = authService.user();
  const isAuthenticated = authService.isAuthenticated();

  // If user is authenticated, redirect to appropriate page
  if (isAuthenticated && user) {
    if (user.role === 'Admin') {
      return router.createUrlTree(['/dashboard']);
    } else if (user.role === 'Bidder') {
      return router.createUrlTree(['/bid-sheets']);
    }
  }

  // Allow access to login page if not authenticated
  return true;
};
